/**
 * @fileoverview GET handler for the "/companies/:company_id/oauth_mcp_settings/marketplace_clients" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdOauthMcpSettingsMarketplaceClients } from "./constants";
import type { GetCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsResult } from "./types";
import { isGetCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsResult } from "./validators";

export const getCompaniesCompanyIdOauthMcpSettingsMarketplaceClients = reactQueryFetcherAdapter(
  companiesCompanyIdOauthMcpSettingsMarketplaceClients,
  (
    signal: AbortSignal,
    companyId: string
  ): Promise<GetCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsResult> => {
    return fetch(`/companies/${companyId}/oauth_mcp_settings/marketplace_clients`, "GET", {}, { signal });
  },
  isGetCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsResult
);
